import type { Dispatch, SetStateAction } from "react";
import { useEffect, useState } from "react";

export const useIsFocusedState = (focusTrigger: boolean): [boolean, Dispatch<SetStateAction<boolean>>] => {
    const [isFocused, setIsFocused] = useState(false);

    useEffect(() => {
        setIsFocused(focusTrigger ? true : false);
    }, [focusTrigger]);

    return [isFocused, setIsFocused];
};
